import { Outlet } from "react-router-dom";
import { HorizontalNavigation } from "../navigation/HorizontalNavigation";
import Header from "../header/Header";

const SchoolContent = () => {
  return (
    <>
      {/* <Header /> */}

      <main className="flex-1 backdrop-blur-[0.5px] p-4 min-h-[60vh] pb-64">
        <div className="max-w-full">
          <Outlet />
        </div>
      </main>
    </>
  );
};

const SchoolLayout = () => {
  return (
    <>
      <HorizontalNavigation />

      <SchoolContent />
    </>
  );
};

export default SchoolLayout;
